import { type RefObject, useLayoutEffect, useRef } from 'react'

import {
  registerAnalyticsFrame,
  updateAnalyticsFrame
} from 'shared/services/analytics/navigation/analyticsFrames'

export const useAnalyticsFrame = (
  ref: RefObject<HTMLIFrameElement>,
  state: { id: string; title: string; visible: boolean; active: boolean }
) => {
  const { id, visible, active } = state
  const stateRef = useRef(state)
  stateRef.current = state
  // Registration resets the frame's route and document tracking, so only a
  // different window re-registers. The title is read once, at registration.
  // Assumes the window keeps one iframe element for its lifetime (WindowContent
  // renders a single memoized iframe); a replaced element is not picked up.
  useLayoutEffect(() => {
    const iframe = ref.current
    if (!iframe) return
    return registerAnalyticsFrame({
      ...stateRef.current,
      id,
      appId: id,
      iframe
    })
  }, [ref, id])
  useLayoutEffect(() => {
    if (ref.current) updateAnalyticsFrame(ref.current, { visible, active })
  }, [ref, visible, active])
}
